import React from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'

import i18n from '../../i18n'

const NoticeModal = (props) => {
  return (
    <Modal className='notice-modal' isOpen={props.isOpen} centered={true}>
      <ModalHeader toggle={props.toggle}>
        {props.title}
      </ModalHeader>
      <ModalBody>
        {props.body}
      </ModalBody>
      <ModalFooter>
        <Button onClick={props.toggle} className="btn mfc-btn-gray medium">{i18n.t("common.ok")}</Button>
      </ModalFooter>
    </Modal>
  )
}

export default NoticeModal
